var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21 21H7.32M7.32 21C5.80786 21 5.05179 21 4.47423 20.7057C3.96619 20.4469 3.55314 20.0338 3.29428 19.5258C3 18.9482 3 18.1921 3 16.68M7.32 21H7.68M3 16.68V3M3 16.68V16.32M12 21C12 16.0294 7.97056 12 3 12",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.81bab0458dae7f6931de3d4492b703b1.svg";
export { ForwardRef as ReactComponent };